import { useCallback } from "react";
import toast from "react-hot-toast";

export default () => {
  const addNotification = useCallback((data = {}) => {
    const settings = {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: true,
      newestOnTop: false,
      closeOnClick: false,
      theme: "light",
      style: {
        boxShadow: "rgb(0 0 0 / 20%) 0px 5px 10px 0px",
        padding: "10px",
        borderRadius: "40px",
        fontSize: "12px",
        marginTop: "5px"
      }
    };

    if (data.ok) {
      settings.iconTheme = {
        primary: "#000",
        secondary: "#f7f7f7"
      };
    } else {
      settings.iconTheme = {
        primary: "#ff7d4c",
        secondary: "#ffdcc6"
      };
    }

    if (data.ok)
      toast.success(data.message, settings);
    else toast.error(data.message, settings);
  }, []);

  return { addNotification };
};
